import { render, staticRenderFns } from "./Illustration.vue?vue&type=template&id=82b8dca4&scoped=true&"
import script from "./Illustration.vue?vue&type=script&lang=js&"
export * from "./Illustration.vue?vue&type=script&lang=js&"
import style0 from "./Illustration.vue?vue&type=style&index=0&id=82b8dca4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82b8dca4",
  null
  
)

export default component.exports